import React from 'react';
import PropTypes from 'prop-types';
import { Helmet as ReactHelmet } from 'react-helmet';

class Helmet extends React.Component {
  static defaultProps = {
    title: '',
  }

  render() {
    const { title } = this.props;
    const siteTitle = title ? `${title} - Affiliate After Hours | Affiliate World Asia` : 'Affiliate After Hours | Affiliate World Asia';
    return (
      <ReactHelmet>
        <title>{siteTitle}</title>
        <meta name="description" content="Come and hang with 1,400 of the industry’s biggest affiliates for an evening of reuniting with old friends and making new ones. Expect secrets to be spilled as the cocktails flow. Capacity is limited." />
        <meta name="twitter:title" content={siteTitle} />
        <meta property="og:title" content={siteTitle} />
      </ReactHelmet>
    );
  }
}

Helmet.propTypes = {
  title: PropTypes.string,
};

export default Helmet;



// WEBPACK FOOTER //
// ./src/components/Helmet/index.js